<div class="coverage-reporting-container">
  <app-coverage-tab
    [projectId]="projectId"
    [projectName]="projectName"
    [projectColors]="projectColors"
  ></app-coverage-tab>
</div>
